const USERS_TABLE_READY = "users-table-ready"
const SEARCH_TEXT_STATE = "users-table-search-text-state"
const ROWS_PER_PAGE_STATE = "users-table-rows-per-page-state"
const PAGINATION_STATE = "users-table-pagination-state"

const USER_ID_FOR_ACTION = "users-table-user-id-for-action"


const initialState = {
    isUsersTableReady: true,
    users: {},

    
    userSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case USERS_TABLE_READY:
            return Object.assign({}, state, { isUsersTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case USER_ID_FOR_ACTION:
            return Object.assign({}, state, {userSelectedId:action.payload})

        default:
        return state
    
    }

}

export function userTableReady(data) {
    return {
        type: USERS_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function userIdForAction(userId){
    return{
        type:USER_ID_FOR_ACTION,
        payload:userId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Users/redux/users.js